import { OTHER_TYPE } from './constants';
import { allTypes } from './operators';

export const hasViewName = (columnName) =>
  typeof columnName === 'string' && columnName.split('.').length === 2;

export const getFullColumnName = (viewName, columnName) =>
  hasViewName(columnName) ? columnName : `${viewName}.${columnName}`;

export const getColumnType = (column, columns) => {
  const columnType = columns.find((c) => c.value === column)?.dataType;
  return allTypes.includes(columnType) ? columnType : OTHER_TYPE;
};
